import { create } from 'zustand';

import { ZorGeneralSetting } from '@/types/zor.general-setting.type';

export interface ZorGeneralSettingState {
  zorGeneralSetting: ZorGeneralSetting | undefined;
  setZorGeneralSetting: (zorGeneralSetting: ZorGeneralSetting) => void;
}

const useZorGeneralSettingStore = create<ZorGeneralSettingState>((set) => ({
  zorGeneralSetting: undefined,
  setZorGeneralSetting: (zorGeneralSetting: ZorGeneralSetting) =>
    set(() => ({ zorGeneralSetting })),
}));

export { useZorGeneralSettingStore };
